import React from "react";

export const OtherAppliancesSVGIcon = ({ status }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={status === "active" ? "category-svg-active" : "category-svg-inactive"}
    >
      <path
        className="svg-path"
        d="M1.65625 4.13825H7.44925V1.65625H1.65625V4.13825ZM3.31025 2.89725H5.79225V3.72525H3.31025V2.89725Z"
      />
      <path
        className="svg-path"
        d="M6.20312 10.3438H17.7881V11.1717H6.20312V10.3438Z"
      />
      <path
        className="svg-path"
        d="M10.3438 0H13.6537V1.654H10.3438V0Z"
      />
      <path
        className="svg-path"
        d="M6.72512 8.61137C6.56852 8.70584 6.43847 8.83852 6.34717 8.99699C6.25587 9.15546 6.20631 9.33452 6.20312 9.51738H17.7891C17.7861 9.33459 17.7368 9.15556 17.6456 8.99709C17.5545 8.83861 17.4246 8.70589 17.2681 8.61137C16.2057 7.96938 15.3197 7.07328 14.6897 6.00375C14.0597 4.93421 13.7056 3.7248 13.6591 2.48438H10.3331C10.2869 3.72486 9.93292 4.93437 9.30311 6.00408C8.6733 7.07378 7.78739 7.9701 6.72512 8.61238V8.61137Z"
      />
      <path
        className="svg-path"
        d="M8.431 5.845C9.1363 4.76845 9.51327 3.51001 9.516 2.223V0H0V5.792H8.433L8.431 5.845ZM8.275 4.55C8.275 4.6598 8.23138 4.7651 8.15374 4.84274C8.0761 4.92038 7.9708 4.964 7.861 4.964H1.24C1.1856 4.96413 1.1317 4.95351 1.08141 4.93275C1.03112 4.912 0.985434 4.88151 0.946964 4.84304C0.908494 4.80457 0.878004 4.75887 0.857245 4.70859C0.836486 4.6583 0.825868 4.6044 0.826 4.55V1.241C0.825868 1.1866 0.836486 1.1327 0.857245 1.08241C0.878004 1.03212 0.908494 0.986433 0.946964 0.947964C0.985434 0.909494 1.03112 0.879004 1.08141 0.858245C1.1317 0.837486 1.1856 0.826868 1.24 0.827H7.861C7.9708 0.827 8.0761 0.870618 8.15374 0.948258C8.23138 1.0259 8.275 1.1312 8.275 1.241V4.55Z"
      />
      <path
        className="svg-path"
        d="M14.4844 0V2.223C14.4871 3.51001 14.8641 4.76845 15.5694 5.845V5.792H24.0024V0H14.4844ZM23.1744 4.552C23.1744 4.6618 23.1308 4.7671 23.0531 4.84474C22.9755 4.92238 22.8702 4.966 22.7604 4.966H16.1384C16.084 4.96613 16.0301 4.95551 15.9798 4.93475C15.9295 4.914 15.8838 4.88351 15.8453 4.84504C15.8069 4.80657 15.7764 4.76088 15.7556 4.71059C15.7349 4.6603 15.7242 4.6064 15.7244 4.552V1.241C15.7242 1.1866 15.7349 1.1327 15.7556 1.08241C15.7764 1.03212 15.8069 0.986433 15.8453 0.947964C15.8838 0.909494 15.9295 0.879004 15.9798 0.858245C16.0301 0.837486 16.084 0.826868 16.1384 0.827H22.7594C22.8692 0.827 22.9745 0.870618 23.0521 0.948258C23.1298 1.0259 23.1734 1.1312 23.1734 1.241L23.1744 4.552Z"
      />
      <path
        className="svg-path"
        d="M16.5547 4.13825H22.3477V1.65625H16.5547V4.13825ZM18.2107 2.89725H20.6927V3.72525H18.2097L18.2107 2.89725Z"
      />
      <path
        className="svg-path"
        d="M0 23.5859H6.619V23.9999H0V23.5859Z"
      />
      <path
        className="svg-path"
        d="M3.72656 22.7553H6.62656V19.4453H3.72656V22.7553ZM4.55456 19.8553H5.79556V20.6833H4.55256L4.55456 19.8553Z"
      />
      <path
        className="svg-path"
        d="M0 18.2031H6.619V18.6171H0V18.2031Z"
      />
      <path
        className="svg-path"
        d="M2.895 19.4453H0V22.7553H2.9L2.895 19.4453ZM2.067 20.6853H0.826V19.8573H2.067V20.6853Z"
      />
      <path
        className="svg-path"
        d="M17.3828 23.9986H24.0038V21.5156H17.3828V23.9986ZM17.7968 21.9296H18.6238V23.5846H17.7968V21.9296Z"
      />
      <path
        className="svg-path"
        d="M17.3828 20.6861H24.0038V18.2031H17.3828V20.6861ZM17.7968 18.6171H18.6238V20.2721H17.7968V18.6171Z"
      />
      <path
        className="svg-path"
        d="M9.10156 19.8594H14.8946V20.2734H9.10156V19.8594Z"
      />
      <path
        className="svg-path"
        d="M7.44531 23.9961H16.5453V18.2031H7.44531V23.9961ZM8.27331 19.4451C8.27318 19.3907 8.2838 19.3368 8.30456 19.2865C8.32532 19.2362 8.35581 19.1906 8.39428 19.1521C8.43275 19.1136 8.47844 19.0831 8.52873 19.0624C8.57901 19.0416 8.63291 19.031 8.68731 19.0311H15.3073C15.3617 19.031 15.4156 19.0416 15.4659 19.0624C15.5162 19.0831 15.5619 19.1136 15.6003 19.1521C15.6388 19.1906 15.6693 19.2362 15.6901 19.2865C15.7108 19.3368 15.7214 19.3907 15.7213 19.4451V22.7551C15.7214 22.8095 15.7108 22.8634 15.6901 22.9137C15.6693 22.964 15.6388 23.0097 15.6003 23.0482C15.5619 23.0866 15.5162 23.1171 15.4659 23.1379C15.4156 23.1586 15.3617 23.1693 15.3073 23.1691H8.68531C8.63091 23.1693 8.57701 23.1586 8.52673 23.1379C8.47644 23.1171 8.43075 23.0866 8.39228 23.0482C8.35381 23.0097 8.32332 22.964 8.30256 22.9137C8.2818 22.8634 8.27118 22.8095 8.27131 22.7551L8.27331 19.4451Z"
      />
      <path
        className="svg-path"
        d="M9.10156 21.1016H14.8946V22.3416H9.10156V21.1016Z"
      />
      <path
        className="svg-path"
        d="M0 13.2409C0 13.5683 0.097064 13.8882 0.278918 14.1604C0.460772 14.4326 0.719247 14.6447 1.02166 14.77C1.32407 14.8952 1.65684 14.928 1.97787 14.8641C2.29891 14.8003 2.59381 14.6427 2.82526 14.4112C3.05672 14.1797 3.21434 13.8849 3.2782 13.5638C3.34206 13.2428 3.30928 12.91 3.18402 12.6076C3.05876 12.3052 2.84663 12.0467 2.57447 11.8649C2.30231 11.683 1.98233 11.5859 1.655 11.5859C1.21623 11.5865 0.795581 11.761 0.485323 12.0713C0.175065 12.3815 0.000529278 12.8022 0 13.2409Z"
      />
      <path
        className="svg-path"
        d="M1.24269 10.7982C1.51612 10.7485 1.79626 10.7485 2.06969 10.7982V8.69215C2.07244 8.63614 2.06379 8.58015 2.04425 8.52759C2.02472 8.47502 1.9947 8.42697 1.95603 8.38635C1.91737 8.34573 1.87085 8.3134 1.81931 8.2913C1.76776 8.26921 1.71227 8.25781 1.65619 8.25781C1.60011 8.25781 1.54461 8.26921 1.49307 8.2913C1.44152 8.3134 1.39501 8.34573 1.35634 8.38635C1.31767 8.42697 1.28766 8.47502 1.26812 8.52759C1.24859 8.58015 1.23993 8.63614 1.24269 8.69215V10.7982Z"
      />
      <path
        className="svg-path"
        d="M22.3425 11.5859C22.0152 11.5859 21.6952 11.683 21.423 11.8649C21.1509 12.0467 20.9387 12.3052 20.8135 12.6076C20.6882 12.91 20.6554 13.2428 20.7193 13.5638C20.7832 13.8849 20.9408 14.1797 21.1722 14.4112C21.4037 14.6427 21.6986 14.8003 22.0196 14.8641C22.3407 14.928 22.6734 14.8952 22.9758 14.77C23.2783 14.6447 23.5367 14.4326 23.7186 14.1604C23.9004 13.8882 23.9975 13.5683 23.9975 13.2409C23.997 12.8022 23.8224 12.3815 23.5122 12.0713C23.2019 11.761 22.7813 11.5865 22.3425 11.5859Z"
      />
      <path
        className="svg-path"
        d="M21.9302 10.7982C22.2036 10.7485 22.4838 10.7485 22.7572 10.7982V8.69215C22.7599 8.63614 22.7513 8.58015 22.7318 8.52759C22.7122 8.47502 22.6822 8.42697 22.6435 8.38635C22.6049 8.34573 22.5583 8.3134 22.5068 8.2913C22.4553 8.26921 22.3998 8.25781 22.3437 8.25781C22.2876 8.25781 22.2321 8.26921 22.1806 8.2913C22.129 8.3134 22.0825 8.34573 22.0438 8.38635C22.0052 8.42697 21.9752 8.47502 21.9556 8.52759C21.9361 8.58015 21.9274 8.63614 21.9302 8.69215V10.7982Z"
      />
      <path
        className="svg-path"
        d="M9.10156 16.5546V17.3826H9.92956V16.9686H10.7566V16.1406H9.51456C9.46024 16.1406 9.40646 16.1513 9.35628 16.1722C9.30611 16.193 9.26054 16.2235 9.22217 16.2619C9.18381 16.3004 9.15341 16.346 9.13271 16.3963C9.11202 16.4465 9.10143 16.5003 9.10156 16.5546Z"
      />
      <path
        className="svg-path"
        d="M11.5859 16.1406H12.4129V17.3816H11.5859V16.1406Z"
      />
      <path
        className="svg-path"
        d="M14.4822 16.1406H13.2422V16.9686H14.0702V17.3826H14.8982V16.5546C14.8983 16.5001 14.8876 16.446 14.8668 16.3956C14.8459 16.3452 14.8152 16.2994 14.7765 16.2609C14.7378 16.2224 14.6919 16.1919 14.6414 16.1713C14.5909 16.1507 14.5368 16.1402 14.4822 16.1406Z"
      />
      <path
        className="svg-path"
        d="M2.06819 7.51719V6.61719H1.24219V7.51719C1.50851 7.41568 1.80187 7.41568 2.06819 7.51719Z"
      />
      <path
        className="svg-path"
        d="M22.7557 7.51719V6.61719H21.9297V7.51719C22.196 7.41568 22.4894 7.41568 22.7557 7.51719Z"
      />
    </svg>
  );
}
